<template>
    <app-button
        v-test-id="attrTestId"
        secondary
        :color="attrColor"
        icon-left="logout"
        :text="text || buttonText"
        @click="logout"
    />
</template>

<script>
import { redirectToLogout, redirectToLogin } from '@/lib/auth';
import getAlertType from '@/lib/helpers/getAlertType';
import dialog from '@/lib/helpers/dialog';
import User from '@/models/User';

export default {
    name: 'AppLogoutButton',
    props: {
        allDevices: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: null
        },
        signoutUrl: {
            type: String,
            default: null
        }
    },
    computed: {
        attrTestId() {
            return this.allDevices ? 'platform-button-logout-all' : 'platform-button-logout';
        },
        attrColor() {
            return this.allDevices ? 'error darken-2' : 'primaryText';
        },
        buttonText() {
            return this.allDevices ? this.$t('logout_all_devices') : this.$t('logout');
        }
    },
    methods: {
        logout() {
            if (!this.Auth().has_user || !this.allDevices) {
                this.logoutCurrentDevice();
            } else if (this.allDevices) {
                this.logoutAllDevices();
            }
        },
        logoutCurrentDevice() {
            redirectToLogout(window.location.origin, this.signoutUrl ? this.signoutUrl : this.Auth().signout_url);
        },
        logoutAllDevices() {
            dialog({
                color: getAlertType('error').color,
                cancelButtonText: this.$t('stay_logged_in'),
                title: this.$t('are_you_sure'),
                text: this.$t('proceeding_will_logout_all_devices'),
                onContinueFn: this.attemptLogoutAllDevices
            });
        },
        async attemptLogoutAllDevices() {
            try {
                await User.api.logoutAllDevices(this.Auth().user_id);
                redirectToLogin();
            } catch (error) {
                this.handleError(error, this.attemptLogoutAllDevices);
            }
        }
    }
};
</script>
